import React, { useContext, useEffect, useState } from "react";
import Header from '../Header'
import moment from "moment";
import EncodingService from "../api/encoding/EncodingService";
import { isEmpty } from 'lodash';
import brand from "@veneer/hp-brand";
import { AuthContext } from "../auth/AuthContext";
import NavbarISO from "../NavbarISO";
import Navigation from "../Navigation";
import { IconChevronLeft, IconChevronRight, Table } from "@veneer/core";
import Footer from "../Footer";
import Notices from "../components/Notices";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";


const Account = (props) => {

    const [date, setDate] = useState(new Date())
    const [createDate, setCreateDate] = useState("")
    const [current, setCurrent] = useState(moment(date).format("MMMM YYYY"))
    const [counter, setCounter] = useState(0)
    const [prev1, setPrev1] = useState('black')
    const [next1, setNext1] = useState('black')
    const [currBold, setCurrBold] = useState('f-w')
    const [cursor11, setCursor11] = useState('pointer')
    const [adjustment, setAdjustment] = useState(0)
    const [usageList, setUsageList] = useState([])
    const [reportMonth, setReportMonth] = useState('')
    const [reportYear, setReportYear] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [pointerEventsDA, setPointerEventsDA] = useState('auto')
    const [pointerEventsColorDA, setPointerEventsColorDA] = useState('')
    const [pointerEventsDU, setPointerEventsDU] = useState('auto')
    const [pointerEventsColorDU, setPointerEventsColorDU] = useState('')
    const [prevDisabled, setPrevDisabled] = useState(false)
    const [nextDisabled, setNextDisabled] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)

    const { uiAccess } = useContext(AuthContext);

    useEffect(() => {
        EncodingService.getBusiness(props.businessId).then(res => {
            setCreateDate(res?.data?.createDate)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
        setMonthlyData(moment().month(), moment().year());
        let query = new URLSearchParams(window.location.hash.split('?')[1]);
        const err = query.get("error");
        if (!isEmpty(err)) {
            setError('Error downloading file. Please try again later')
        }
    }, [])

    const linkClickedDownloadAnalytics = () => {
        setPointerEventsDA('none');
        setPointerEventsColorDA(brand.color.gray)
        setTimeout(() => {
            setPointerEventsDA('auto')
            setPointerEventsColorDA('#024ad8')

        }, 5000);
        setError('')
    }

    const linkClickedDownloadUsage = () => {
        setPointerEventsDU('none');
        setPointerEventsColorDU(brand.color.gray)

        setTimeout(() => {
            setPointerEventsDU('auto')
            setPointerEventsColorDU('#024ad8')
        }, 5000);

        setError('')
    }

    const setMonthlyData = (month, year) => {
        setReportMonth(month + 1);
        setReportYear(year);
        setLoading(true);

        EncodingService.getMonthlyData(month + 1, year).then((res) => {
            let usageData = res?.data?.usage
            setAdjustment(res?.data?.adjustmentDescription);
            setLoading(false);
            let listDataTable = [];

            if (usageData) {
                usageData.forEach((item) => {
                    let obj = {
                        encodedSupplyDescription: < div className="encodedesc">{item.encodedSupplyDescription}</div>,
                        priceDescription: <div className="totaldesc1" style={{ textAlign: "right" }}>{item.priceDescription}</div>,
                        cap: <div className="account-cap" style={{ textAlign: "right" }}> {item.cap}</div>,
                        used: <div className="account-used" style={{ textAlign: "right" }}> {item.used}</div>,
                        totalDescription: <div className="totaldesc" style={{
                            textAlign: "right",
                            whiteSpace: "nowrap",
                            width: "100%",
                        }}>{item.totalDescription}</div>,
                    }
                    listDataTable.push(obj)
                });
            }
            setUsageList(listDataTable)
        }).catch(() => {
            removeLocalStorageItem(AUTHENTICATED);
            window.location.href = "/supplyencodingsvc/?state=Error";
        });
    };

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const handlePageSizeChange = (event, option) => {
        setPageSize(option.value)
    }

    const previousMonth = () => {
        setCurrentPage(1);
        setPageSize(10);
        setNext1('black')
        setNextDisabled(false)
        setCursor11('pointer')
        const previousDate = moment(date).add(-1, "months");
        if (moment(createDate).format("MMMM YYYY") !== moment(date).format("MMMM YYYY")) {

            let c = counter;
            c--;
            setCounter(c)
            setPrev1('black')
            setPrevDisabled(false)
            setCursor11('pointer')

            if (moment(createDate).format("MMMM YYYY") === moment(previousDate).format("MMMM YYYY")) {

                setPrev1('grey')
                setPrevDisabled(true)
                setCursor11('default')
            } else {
                setPrev1('black')
                setPrevDisabled(false)
                setCursor11('pointer')
            }
            setCurrent(moment(previousDate).format("MMMM YYYY"));
            if (moment(previousDate).format("MMMM YYYY") === c)
                setCurrBold('f-w')
            else setCurrBold('')
        }
        if (
            moment(new Date()).format("MMMM YYYY") ===
            moment(previousDate).format("MMMM YYYY")
        )
            setCurrBold('f-w')
        else setCurrBold('')
        let currentMonth = moment(date).month()
        let currentYear = moment(date).year()
        if (currentMonth === 0) {
            currentMonth = 12;
            currentYear--;
        }
        setMonthlyData(currentMonth - 1, currentYear)
        setDate(previousDate)
    }

    const nextMonth = () => {
        setCurrentPage(1);
        setPageSize(10);
        setPrev1('black')
        setPrevDisabled(false)
        setCursor11('pointer')
        const nextDate = moment(date).add(1, "months")
        if (counter < 6) {
            let c = counter;
            c++;
            setCounter(c)
            setCurrent(moment(nextDate).format("MMMM YYYY"))

            if (c === 6) {
                setNext1('grey')
                setNextDisabled(true)
                setCursor11('default')
            } else {
                setNext1('black')
                setNextDisabled(false)
                setCursor11('pointer')
            }
        }
        if (
            moment(new Date()).format("MMMM YYYY") ===
            moment(nextDate).format("MMMM YYYY")
        )
            setCurrBold('f-w')
        else setCurrBold('')
        setMonthlyData(moment(nextDate).month(), moment(nextDate).year());
        setDate(nextDate)

    }

    const presentMonth = () => {
        const presentDate = new Date();
        setCounter(0);
        setCurrent(moment(presentDate).format("MMMM YYYY"))
        setCurrBold('f-w');
        setNext1('black');
        setPrev1(moment(presentDate).format("MMMM YYYY") === moment(createDate).format("MMMM YYYY") ? "grey" : "black");
        setPrevDisabled(moment(presentDate).format("MMMM YYYY") === moment(createDate).format("MMMM YYYY"),)
        setNextDisabled(false)
        setMonthlyData(moment(presentDate).month(), moment(presentDate).year());
        setDate(presentDate)
    }

    return (
        <div>
            <Header />

            {uiAccess?.navbarISO && <NavbarISO role={props.role} />}
            {uiAccess?.navigation && <Navigation role={props.role} />}

            <Notices />

            <div className="tableWrapper">
                <div className="row justify-content-start p-100">
                    <div className="col-md-7 col-sm-6 col-xs-6">
                        <h5 className="subtitle-large">Monthly summary </h5>
                    </div>

                </div>

                <div className="col-md-10 currentAdjustments">

                    <div className="font-hp p-b-20 monthly">
                        <div id={'monthsNavigationAcc'}>
                            <div className=" font-hp current-month-mp">
                                <span role="link" id="currentMonthName" onClick={presentMonth}>
                                    Current month
                                </span>
                            </div>
                            <div className={'row p-l'}>
                                <div
                                    role="link"
                                    style={{ color: prev1, cursor: cursor11 }}
                                    onClick={() => !prevDisabled && previousMonth()}
                                    id="previousMonth"
                                    className="c-p p-r-10"
                                >
                                    Previous month
                                    <IconChevronLeft />
                                </div>
                                <div className={currBold} id="p-c">
                                    {current}
                                </div>

                                <div
                                    role="link"
                                    style={{ color: next1, cursor: cursor11 }}
                                    onClick={() => !nextDisabled && nextMonth()}
                                    className="c-p"
                                    id="nextMonth"
                                >
                                    <IconChevronRight />
                                    Next month
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="tableWrapper">
                <div className="row justify-content-start">
                    <div className="col-md-10">
                        <Table
                            columnResize={true}
                            id="account"
                            className={'account'}
                            loading={loading}
                            columns={[
                                {
                                    id: 'encodedSupplyDescription',
                                    label: "Encoded Supply",
                                },
                                {
                                    id: 'priceDescription',
                                    label: <div style={{ width: "100%", textAlign: "right" }}>Price (US$)</div>,
                                    sortable: false,
                                },
                                {
                                    id: 'cap',
                                    label: <div style={{ width: "100%", textAlign: "right" }}>Cap</div>,
                                },
                                {
                                    id: 'used',
                                    label: <div style={{ width: "100%", textAlign: "right" }}>Used</div>,
                                },
                                {
                                    id: 'totalDescription',
                                    label: <div style={{ width: "100%", textAlign: "right" }}>Usage total* (US$)</div>,
                                },
                            ]}
                            data={usageList.slice((currentPage - 1) * pageSize,
                                (currentPage - 1) * pageSize + pageSize)}
                            pagination={{
                                currentPage: currentPage,
                                pageSizeOptions: usageList.length <= 2 ? [{ value: usageList.length }] :
                                    usageList.length < 5 ? [{ value: 2 }, { value: usageList.length }] :
                                        usageList.length <= 8 ? [{ value: 2 }, { value: 4 }, { value: usageList.length }] :
                                            usageList.length <= 9 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: usageList.length }] :
                                                usageList.length <= 10 ? [{ value: 2 }, { value: 4 }, { value: 8 }, { value: usageList.length }] : [{ value: 2 }, { value: 4 }, { value: 8 }, { value: 10 }, { value: usageList.length }],
                                onPageChange: handlePageChange,
                                onPageSizeChange: handlePageSizeChange,
                                totalItems: usageList.length,
                                pageSize: pageSize
                            }}
                            loadingDataLength={pageSize}
                        />

                        <div className="col-md-12 p-0">
                            <div className="">
                                <div className="adjustment p-50 p-b">
                                    <div className=" font-hp mr-5" style={{ display: "flex", alignItems: "center", gap: "20px" }}>Adjustment (US$)&ensp;

                                        <div className="inputValue">
                                        <input
                                            type="text"
                                            className="totalamt b-0-r"
                                            id="totalAmount"
                                            name="adjustment"
                                            readOnly
                                            value={adjustment}
                                        />
                                        </div>
                                    </div>

                                   

                                </div>{" "}



                            </div>
                            <div className="b-b"></div>
                            <div className="font-hp">
                                *Tax/VAT and other adjustments not included
                            </div>
                        </div>

                        <div className="row justify-content-end">
                            <div className="col-6 c-r">
                                {error}
                            </div>
                            <div className="col-3">
                                <span className="c-b-f f-r" id="AccountdownloadAnalytics">
                                    <a className="a-link" style={{ pointerEvents: pointerEventsDA, color: '#024ad8' }}
                                        onClick={linkClickedDownloadAnalytics}
                                        href={`${process.env.REACT_APP_PUBLIC_URL}/v1/export/analytics/${reportYear}/${reportMonth}`}>Download Analytics</a>
                                </span>
                            </div>
                            <div className="col-3 ">
                                <span className="c-b-f f-r" id="AccountdownloadUsage">
                                    <a className="a-link" style={{ pointerEvents: pointerEventsDU, color: '#024ad8' }}
                                        href={`${process.env.REACT_APP_PUBLIC_URL}/v1/export/excel/${reportYear}/${reportMonth}`}
                                        onClick={linkClickedDownloadUsage}>Download Usage</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Account;